// ─── Gingeria doughnut chart ──────────────────────────────────────────
// Inicijalizuje se ovde (a ne inline u Liquid sekciji) zato što inline
// <script> u sekciji se izvršava pre nego što se Chart.js biblioteka učita,
// pa Chart nije definisan. gingeria-landing.js se učitava posle chart.js
// preko {{ ... | script_tag }}, tako da je Chart sigurno dostupan ovde.
(function(){
  function initChart(){
    var canvas = document.getElementById('myChart');
    if (!canvas || typeof Chart === 'undefined') return;
    if (window.gingeriaChart) return; // već inicijalizovan
    var ctx = canvas.getContext('2d');
    window.gingeriaChart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: ['Bez napretka', 'Delimični rezultati', 'Potpuni rezultati'],
        datasets: [{
          label: '%',
          data: [6, 5, 89],
          backgroundColor: ['rgb(255, 99, 132)','rgb(75, 192, 192)','rgb(54, 162, 235)'],
          borderWidth: 1
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' }
        }
      }
    });
  }

  initChart();
})();

// ─── Gingeria shared translations loader ──────────────────────────────
// Učitava lokalizovani JSON jednom; rezultat se izlaže preko
// window.gingeriaTranslations (Promise) tako da ga i i18n loader i price
// modul mogu konzumirati bez dupliranja fetch-a.
//
// Liquid pre-registruje URL-ove za sve podržane jezike u window.gingeriaI18n.
// Ako konkretan <lang>-gingeria.json fajl ne postoji (404), tiho prelazimo
// na defaultLang (HR). Dakle: dropuj novi JSON u assets/ i radi automatski.
(function(){
  if (!window.gingeriaI18n || !window.gingeriaI18n.locales) {
    window.gingeriaTranslations = Promise.resolve({});
    return;
  }

  function detectLang(){
    var path = (window.location.pathname || '').toLowerCase();
    var m = path.match(/^\/([a-z]{2})(?:-[a-z]{2})?(?:\/|$)/);
    if (m && window.gingeriaI18n.locales[m[1]]) return m[1];
    var shop = (window.gingeriaI18n.shopLocale || '').toLowerCase().slice(0,2);
    if (shop && window.gingeriaI18n.locales[shop]) return shop;
    var html = (document.documentElement.lang || '').toLowerCase().slice(0,2);
    if (html && window.gingeriaI18n.locales[html]) return html;
    return window.gingeriaI18n.defaultLang || 'hr';
  }

  function loadJson(u){
    return fetch(u, { credentials: 'same-origin' }).then(function(r){
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  var lang = detectLang();
  // Izloži detektovani jezik da ga buy handler može mapirati u market prefiks.
  window.gingeriaI18n._lang = lang;
  var defaultLang = window.gingeriaI18n.defaultLang || 'hr';
  var url = window.gingeriaI18n.locales[lang];
  var fallbackUrl = window.gingeriaI18n.locales[defaultLang];

  if (!url) { window.gingeriaTranslations = Promise.resolve({}); return; }

  window.gingeriaTranslations = loadJson(url)
    .catch(function(e){
      if (lang === defaultLang || !fallbackUrl) throw e;
      console.info('[gingeria-i18n] ' + lang + '-gingeria.json nije pronađen, fallback na ' + defaultLang);
      return loadJson(fallbackUrl);
    })
    .then(function(data){
      return (data && data.sections && data.sections.gingeria_landing) || {};
    })
    .catch(function(e){
      console.warn('[gingeria-i18n] svi pokušaji učitavanja prevoda neuspešni', e);
      return {};
    });
})();

// ─── Gingeria dynamic pricing + bundle ────────────────────────────────
// Učitava cenu sa Shopify product.js endpoint-a, konvertuje u lokalnu
// valutu pomoću Frankfurter API-ja, i ažurira:
//   • [data-i18n="order_price"] na landing stranici
//   • [data-bundle-total], [data-bundle-ppp], [data-bundle-shipping] na
//     bundle picker stranici (cene paketa izračunate iz bazne cene P)
// Pretpostavka: bazna valuta prodavnice je EUR.
(function(){
  var PRODUCT_HANDLE = 'gingeria';
  var SHOP_BASE_CURRENCY = 'EUR';
  var SHIPPING_FEE = 4.99; // u EUR; konvertuje se u lokalnu valutu

  var countryConfig = {
    'hr': { currency: 'EUR', intl: 'hr-HR' },
    'ro': { currency: 'RON', intl: 'ro-RO' },
    'bg': { currency: 'EUR', intl: 'bg-BG' }, // BG je usvojio EUR 2026-01-01
    'sk': { currency: 'EUR', intl: 'sk-SK' },
    'hu': { currency: 'HUF', intl: 'hu-HU' },
    'si': { currency: 'EUR', intl: 'sl-SI' },
    'cz': { currency: 'CZK', intl: 'cs-CZ' },
    'pl': { currency: 'PLN', intl: 'pl-PL' }
  };

  // Fallback kursevi 1 EUR → X. Vrednosti od 2026-05-20 (ECB referentni).
  var fallbackRates = { EUR: 1, RON: 5.2333, HUF: 361.3, CZK: 24.322, PLN: 4.255 };

  function detectCountry(){
    var path = (window.location.pathname || '').toLowerCase();
    var m = path.match(/^\/[a-z]{2}-([a-z]{2})(?:\/|$)/);
    if (m && countryConfig[m[1]]) return m[1];
    var shop = ((window.gingeriaI18n && window.gingeriaI18n.shopLocale) || '').toLowerCase();
    m = shop.match(/-([a-z]{2})$/);
    if (m && countryConfig[m[1]]) return m[1];
    m = shop.match(/^([a-z]{2})/);
    if (m && countryConfig[m[1]]) return m[1];
    return 'hr';
  }

  function formatPrice(amount, currency, intlLocale){
    var noDecimals = currency === 'HUF';
    if (noDecimals) amount = Math.round(amount);
    try {
      return new Intl.NumberFormat(intlLocale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: noDecimals ? 0 : 2,
        maximumFractionDigits: noDecimals ? 0 : 2
      }).format(amount);
    } catch (e) {
      return amount.toFixed(noDecimals ? 0 : 2) + ' ' + currency;
    }
  }

  function fetchProductPrice(){
    return fetch('/products/' + PRODUCT_HANDLE + '.js', { credentials: 'same-origin' })
      .then(function(r){
        if (!r.ok) throw new Error('product.js ' + r.status);
        return r.json();
      })
      .then(function(p){ return p.price / 100; });
  }

  function fetchRates(){
    var others = [];
    Object.keys(countryConfig).forEach(function(c){
      var cur = countryConfig[c].currency;
      if (cur !== SHOP_BASE_CURRENCY && others.indexOf(cur) === -1) others.push(cur);
    });
    if (!others.length) return Promise.resolve({ EUR: 1 });

    return fetch('https://api.frankfurter.dev/v1/latest?from=' + SHOP_BASE_CURRENCY + '&to=' + others.join(','))
      .then(function(r){
        if (!r.ok) throw new Error('frankfurter ' + r.status);
        return r.json();
      })
      .then(function(data){
        var rates = data.rates || {};
        rates[SHOP_BASE_CURRENCY] = 1;
        return rates;
      })
      .catch(function(e){
        console.warn('[gingeria-price] using fallback rates', e);
        return fallbackRates;
      });
  }

  // Cene paketa (u baznoj valuti, EUR):
  //   Bundle 1 (1 boca):   total = P + shipping;  ppp = P
  //   Bundle 2 (2+1 free): total = 2P (free ship); ppp = 2P / 3  (3 boce)
  //   Bundle 3 (3+3 free): total = 3P (free ship); ppp = 3P / 6  (6 boca)
  function computeBundle(num, P){
    if (num === 1) return { total: P + SHIPPING_FEE, ppp: P };
    if (num === 2) return { total: 2 * P,           ppp: (2 * P) / 3 };
    if (num === 3) return { total: 3 * P,           ppp: (3 * P) / 6 };
    return null;
  }

  function updateLandingPrice(localPrice, currency, intlLocale){
    var priceEl = document.querySelector('[data-i18n="order_price"]');
    if (priceEl) priceEl.textContent = formatPrice(localPrice, currency, intlLocale);
  }

  function updateBundlePicker(basePrice, rate, currency, intlLocale, t){
    var picker = document.getElementById('Gingeria-bundle-picker');
    if (!picker) return;
    var unitLabel = (t && t.options_unit) || 'komad';
    var shipLabel = (t && t.options_shipping_label) || 'DOSTAVA';

    [1, 2, 3].forEach(function(num){
      var bundle = computeBundle(num, basePrice);
      if (!bundle) return;
      var localTotal = bundle.total * rate;
      var localPpp   = bundle.ppp   * rate;

      var totalEl = picker.querySelector('[data-bundle-total="' + num + '"]');
      if (totalEl) totalEl.textContent = formatPrice(localTotal, currency, intlLocale);

      var pppEl = picker.querySelector('[data-bundle-ppp="' + num + '"]');
      if (pppEl) pppEl.textContent = formatPrice(localPpp, currency, intlLocale) + ' / ' + unitLabel;

      if (num === 1) {
        var shipEl = picker.querySelector('[data-bundle-shipping="1"]');
        if (shipEl) shipEl.textContent = shipLabel + ' ' + formatPrice(SHIPPING_FEE * rate, currency, intlLocale);
      }
    });
  }

  var country = detectCountry();
  var cfg = countryConfig[country];
  if (!cfg) return;

  Promise.all([
    fetchProductPrice(),
    fetchRates(),
    window.gingeriaTranslations || Promise.resolve({})
  ]).then(function(results){
    var basePrice = results[0];
    var rates = results[1];
    var t = results[2];
    var rate = rates[cfg.currency];
    if (rate == null) rate = fallbackRates[cfg.currency] || 1;

    updateLandingPrice(basePrice * rate, cfg.currency, cfg.intl);
    updateBundlePicker(basePrice, rate, cfg.currency, cfg.intl, t);
  }).catch(function(e){
    console.warn('[gingeria-price] update failed', e);
  });
})();

// ─── Gingeria market prefiks (deljeni helper) ─────────────────────────
// Vraća važeći xx-yy market prefiks za trenutni kontekst. Autoritet je URL
// (to Shopify zaista koristi za jezik stranice); fallback je jezik koji je
// detektovao i18n loader. Store prihvata SAMO xx-yy prefikse - samo-jezik
// (/hr) redirectuje na default market. Country se razlikuje od jezika za:
// cs->cz (Češka), sl->si (Slovenija).
window.gingeriaMarketPrefix = function(){
  var MARKETS = { hr:'hr-hr', ro:'ro-ro', bg:'bg-bg', cs:'cs-cz', hu:'hu-hu', pl:'pl-pl', sk:'sk-sk', sl:'sl-si' };
  var seg = (window.location.pathname || '').toLowerCase().split('/')[1] || '';
  for (var k in MARKETS){ if (MARKETS[k] === seg) return seg; }
  var lang = (window.gingeriaI18n && window.gingeriaI18n._lang) || '';
  return MARKETS[lang] || '';
};

// ─── Gingeria CTA linkovi -> lokalizovana options stranica ────────────
// CTA dugmići ka options stranici moraju da čuvaju market prefiks izvorne
// stranice, inače destinacija pada na default/HR jezik. NE oslanjamo se na
// cta_url iz prevoda (može da faltuje ili kasni, a statički href je hardkodovan
// na hr-hr) - href gradimo direktno iz market prefiksa. cta_url iz JSON-a se
// zato namerno preskače u applyTranslations.
(function(){
  function apply(){
    var market = (window.gingeriaMarketPrefix && window.gingeriaMarketPrefix()) || '';
    var prefix = market ? '/' + market : '';
    document.querySelectorAll('a[data-i18n-href="cta_url"]').forEach(function(a){
      a.setAttribute('href', prefix + '/pages/gingeria-options');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();

// ─── Gingeria bundle picker click handler ─────────────────────────────
// Na klik buy dugmeta, redirect na /<market>/cart/<variant>:<quantity>.
// VAŽNO: /cart/... je root-apsolutna putanja pa NE čuva trenutni market
// prefiks iz URL-a - moramo ga eksplicitno prepend-ovati, inače checkout
// pada na default market (ro-ro / en).
(function(){
  var picker = document.getElementById('Gingeria-bundle-picker');
  if (!picker) return;

  var options = picker.querySelectorAll('.gpbp-option');
  var buyBtn  = picker.querySelector('.gpbp-buy');
  if (!buyBtn) return;

  // Klik bilo gde na karticu bira radio (label-for ovo radi nativno, ali
  // i ako neki browser ne reaguje na click event na inputu - forsiramo).
  options.forEach(function(opt){
    opt.addEventListener('click', function(){
      var input = opt.querySelector('.gpbp-input');
      if (input && !input.checked) input.checked = true;
    });
  });

  buyBtn.addEventListener('click', function(){
    var selected = null;
    options.forEach(function(opt){
      var input = opt.querySelector('.gpbp-input');
      if (input && input.checked) selected = opt;
    });
    if (!selected) {
      var t = (window.gingeriaI18n && window.gingeriaI18n._t) || {};
      alert(t.options_alert_select || 'Molimo izaberite paket.');
      return;
    }
    var meta = selected.querySelector('.gpbp-meta');
    var variantId = meta && meta.dataset.variantId;
    var quantity  = (meta && meta.dataset.quantity) || '1';
    if (!variantId) return;

    var market = window.gingeriaMarketPrefix();
    var url = (market ? '/' + market : '') + '/cart/' + variantId + ':' + quantity;
    picker.dispatchEvent(new CustomEvent('bundle:buy', {
      detail: { variantId: variantId, quantity: Number(quantity), url: url },
      bubbles: true
    }));
    window.location.href = url;
  });
})();

// ─── Gingeria i18n loader ─────────────────────────────────────────────
// Konzumira window.gingeriaTranslations (postavljen u shared loader-u) i
// popunjava sve elemente sa data-i18n / data-i18n-src / data-i18n-href /
// data-i18n-aria-label atributima.
(function(){
  if (!window.gingeriaTranslations) return;

  function applyClinicalLabels(t){
    // Slajdovi u .mod-clinical-carousel i .mod-testimonials-carousel imaju format
    // "<HR label>: <vrednost>" za podatke pacijenata. Pošto su nazivi pacijenata
    // identični po jezicima, samo prevodimo labele i fiksne vrednosti (Muški/Ženski/60 dana).
    var labelMap = {
      'Ime i prezme': t.clinical_label_name,
      'Ime i prezime': t.clinical_label_name,
      'Godine': t.clinical_label_age,
      'Trajanje tretmana': t.clinical_label_duration,
      'Spol': t.clinical_label_gender,
      'Klinički broj': t.clinical_label_number,
      'Dijagnoza po ICD-10': t.clinical_label_diagnosis
    };
    var valueMap = {
      '60 dana': t.clinical_days,
      'Muški': t.clinical_gender_m,
      'Ženski': t.clinical_gender_f
    };
    var ps = document.querySelectorAll('.mod-clinical-carousel p, .mod-testimonials-carousel p');
    ps.forEach(function(p){
      var html = p.innerHTML;
      Object.keys(labelMap).forEach(function(hrLabel){
        var trans = labelMap[hrLabel];
        if (!trans) return;
        // Escape regex special chars
        var pattern = hrLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        html = html.replace(new RegExp(pattern + '(\\s*:)', 'g'), trans + '$1');
      });
      Object.keys(valueMap).forEach(function(hrVal){
        var trans = valueMap[hrVal];
        if (!trans) return;
        var pattern = hrVal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        html = html.replace(new RegExp(pattern, 'g'), trans);
      });
      if (html !== p.innerHTML) p.innerHTML = html;
    });
  }

  function applyTranslations(t){
    if (!t || typeof t !== 'object') return;
    // Izlažemo za druge module (npr. alert u bundle picker-u)
    if (window.gingeriaI18n) window.gingeriaI18n._t = t;

    document.querySelectorAll('[data-i18n]').forEach(function(el){
      var key = el.getAttribute('data-i18n');
      if (t[key] !== undefined) el.innerHTML = t[key];
    });
    document.querySelectorAll('[data-i18n-src]').forEach(function(el){
      var key = el.getAttribute('data-i18n-src');
      if (t[key] !== undefined) el.setAttribute('src', t[key]);
    });
    document.querySelectorAll('[data-i18n-href]').forEach(function(el){
      var key = el.getAttribute('data-i18n-href');
      // cta_url se namerno preskače - option-link href gradi zaseban modul iz
      // market prefiksa (vidi "CTA linkovi -> lokalizovana options stranica").
      if (key === 'cta_url') return;
      if (t[key] !== undefined) el.setAttribute('href', t[key]);
    });
    document.querySelectorAll('[data-i18n-aria-label]').forEach(function(el){
      var key = el.getAttribute('data-i18n-aria-label');
      if (t[key] !== undefined) el.setAttribute('aria-label', t[key]);
    });

    applyClinicalLabels(t);

    // Doughnut chart koristi labele iz JS koda - ažuriraj ako je inicijalizovan
    if (window.gingeriaChart && t.chart_label_1) {
      window.gingeriaChart.data.labels = [t.chart_label_1, t.chart_label_2, t.chart_label_3];
      window.gingeriaChart.update();
    }
  }

  window.gingeriaTranslations.then(applyTranslations);
})();

// Video background responsive height (replaces gfvideobg.js)
(function($){
  $.fn.gfVideoBg=function(){
    return this.each(function(){
      var $m=$(this);
      function r(){$m.find('.gf_video-bg-inner').css({width:'100%',height:'auto'})}
      r();$(window).on('resize',r);
    });
  };
})(jQuery);
(function(jQuery2){var $module=jQuery2("#m-1704382742689").children(".module"),mode=jQuery2(".gryffeditor").hasClass("editing")?"dev":"production";mode=="production"?jQuery2(window).ready(function(){$module.gfVideoBg()}):$module.gfVideoBg()})(window.GemQuery||jQuery),window.GemQuery||jQuery,(function(jQuery2){try{var $module=jQuery2("#m-1705069925097").children(".module"),navspeed=$module.data("navspeed"),autoplaytimeout=$module.data("autoplaytimeout"),autoplayhoverpause=$module.data("autoplayhoverpause"),navlg=$module.data("navlg"),navmd=$module.data("navmd"),navsm=$module.data("navsm"),navxs=$module.data("navxs"),collg=$module.data("collg"),colmd=$module.data("colmd"),colsm=$module.data("colsm"),colxs=$module.data("colxs"),dotslg=$module.data("dotslg"),dotsmd=$module.data("dotsmd"),dotssm=$module.data("dotssm"),dotsxs=$module.data("dotsxs"),marginlg=parseInt($module.data("marginlg")),marginmd=parseInt($module.data("marginmd")),marginsm=parseInt($module.data("marginsm")),marginxs=parseInt($module.data("marginxs")),mode=jQuery2(".gryffeditor").hasClass("editing")?"dev":"production";if(mode=="production")var autoplay=$module.data("autoplay"),autoRefresh=!0,loop=$module.data("loop");else var autoplay=0,autoRefresh=!1,loop=0;var initCarousel=function(){$module.owlCarousel({mouseDrag:!0,touchDrag:!0,autoplayHoverPause:autoplayhoverpause,autoplay:autoplay,autoRefresh:autoRefresh,autoplaySpeed:navspeed,autoplayTimeout:autoplaytimeout,loop:loop,navSpeed:navspeed,autoWidth:!1,responsiveClass:!0,responsive:{0:{items:colxs,nav:navxs,dots:dotsxs,margin:marginxs,slideBy:2},768:{items:colsm,nav:navsm,dots:dotssm,margin:marginsm,slideBy:2},992:{items:colmd,nav:navmd,dots:dotsmd,margin:marginmd,slideBy:2},1200:{items:collg,nav:navlg,dots:dotslg,margin:marginlg,slideBy:2}},onInitialized:function(){$module.closest('.module-wrap').addClass("gf-carousel-loaded"),jQuery2(window).trigger("resize")}})};$module.parent().parent().closest('.module-wrap').length>0?setTimeout(function(){initCarousel()},300):initCarousel()}catch(err){}})(window.GemQuery||jQuery),(function(jQuery2){try{var $module=jQuery2("#m-1705848050983").children(".module"),navspeed=$module.data("navspeed"),autoplaytimeout=$module.data("autoplaytimeout"),autoplayhoverpause=$module.data("autoplayhoverpause"),navlg=$module.data("navlg"),navmd=$module.data("navmd"),navsm=$module.data("navsm"),navxs=$module.data("navxs"),collg=$module.data("collg"),colmd=$module.data("colmd"),colsm=$module.data("colsm"),colxs=$module.data("colxs"),dotslg=$module.data("dotslg"),dotsmd=$module.data("dotsmd"),dotssm=$module.data("dotssm"),dotsxs=$module.data("dotsxs"),marginlg=parseInt($module.data("marginlg")),marginmd=parseInt($module.data("marginmd")),marginsm=parseInt($module.data("marginsm")),marginxs=parseInt($module.data("marginxs")),mode=jQuery2(".gryffeditor").hasClass("editing")?"dev":"production";if(mode=="production")var autoplay=$module.data("autoplay"),autoRefresh=!0,loop=$module.data("loop");else var autoplay=0,autoRefresh=!1,loop=0;var initCarousel=function(){$module.owlCarousel({mouseDrag:!0,touchDrag:!0,autoplayHoverPause:autoplayhoverpause,autoplay:autoplay,autoRefresh:autoRefresh,autoplaySpeed:navspeed,autoplayTimeout:autoplaytimeout,loop:loop,navSpeed:navspeed,autoWidth:!1,responsiveClass:!0,responsive:{0:{items:colxs,nav:navxs,dots:dotsxs,margin:marginxs,slideBy:2},768:{items:colsm,nav:navsm,dots:dotssm,margin:marginsm,slideBy:2},992:{items:colmd,nav:navmd,dots:dotsmd,margin:marginmd,slideBy:2},1200:{items:collg,nav:navlg,dots:dotslg,margin:marginlg,slideBy:2}},onInitialized:function(){$module.closest('.module-wrap').addClass("gf-carousel-loaded"),jQuery2(window).trigger("resize")}})};$module.parent().parent().closest('.module-wrap').length>0?setTimeout(function(){initCarousel()},300):initCarousel()}catch(err){}})(window.GemQuery||jQuery),window.GemQuery||jQuery;
//# sourceMappingURL=/cdn/shop/t/1/assets/gem-page-142341046619.js.map?gemv=1762501396218&v=21183159654664561291729082491
